import { useState } from 'react';

interface EditorJsonProps {
  initialValue: unknown;
  onChange?: (val: unknown) => void;
  variables?: string[];
}

export function EditorJson({ initialValue, onChange, variables = [] }: EditorJsonProps) {
  const [text, setText] = useState(() => JSON.stringify(initialValue, null, 2));
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    setText(val);
    try {
      const parsed = JSON.parse(val);
      setError(null);
      if (onChange) onChange(parsed);
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError(String(err));
      }
    }
  };

  return (
    <div className="editor-json" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {variables.length > 0 && (
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {variables.map((v) => (
            <span
              key={v}
              style={{
                background: 'var(--bg-2)',
                padding: '2px 8px',
                borderRadius: '16px',
                fontSize: '12px',
                border: '1px solid var(--border-2)',
                color: 'var(--text-1)',
              }}
            >
              {v}
            </span>
          ))}
        </div>
      )}
      <textarea
        value={text}
        onChange={handleChange}
        style={{
          width: '100%',
          minHeight: '200px',
          fontFamily: 'monospace',
          padding: '8px',
          borderColor: error ? 'var(--sig-crit-border)' : 'var(--border-2)',
          backgroundColor: 'var(--bg-1)',
          color: 'var(--text-1)',
          outline: 'none',
        }}
      />
      {error && <div style={{ color: 'var(--sig-crit-text)', fontSize: '12px' }}>{error}</div>}
    </div>
  );
}
